import React from "react";
import { Grid, Dialog, Typography, IconButton } from "@material-ui/core";
import { Close } from "@material-ui/icons";
import Cookies from 'universal-cookie';
import { saveAs } from "file-saver";

import { CardProduto } from "../childrens/CardProduto/.mixins";

import Qualidade_controller from '../../../../../../controllers/qualidade';
import Config from '../../../../../../controllers/config';

import { css } from "./styles";

export function Modal(props) {
    const styles = css();

    const handleClickIconDownload = async (atributos, pdf_link) => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        if (pdf_link == null || pdf_link === "") {
            props.childAlert.current.retorno('URL de arquivo vazia!', 'warning');
            return;
        }

      try {
        const query = { key: pdf_link, UserToken: token };
        const o_qualidade = await Qualidade_controller.getDownload(query);
        const o_qualidade_blob = await o_qualidade.blob();

        saveAs(
            o_qualidade_blob,
            `${atributos.alfa}_${atributos.nome_produto}.pdf`
        );
      } catch (error) {
        console.error(error);
      }
    };

    const handleClickIconView = async (pdf_link) => {
      try {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        if (pdf_link == null || pdf_link === "") {
            props.childAlert.current.retorno('URL de arquivo vazia!', 'warning');
            return;
        }

        const query = { key: pdf_link };
        const o_qualidade = await Qualidade_controller.getURLFile(token, query);
        if (o_qualidade.res.statusCode == 200) {
            window.open(o_qualidade.body, "_blank");
        }
      } catch (error) {
        console.error(error);
      }
    };

    const handleClickIconPrint = async (pdf_link) => {
      try {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        if (pdf_link == null || pdf_link === "") {
            props.childAlert.current.retorno('URL de arquivo vazia!', 'warning');
            return;
        }

        const query = { key: pdf_link, UserToken: token };
        const o_qualidade = await Qualidade_controller.getDownload(query);
        const o_qualidade_blob = await o_qualidade.blob();

        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(o_qualidade_blob, "File.pdf"); //Apenas para IE
        } else {
            const fileURL = URL.createObjectURL(o_qualidade_blob);
            const iframe = document.createElement('iframe');
            document.body.appendChild(iframe);

            iframe.style.display = 'none';
            iframe.src = fileURL;
            iframe.onload = () => {
                setTimeout(() => {
                    iframe.focus();
                    iframe.contentWindow.print();
                }, 1);
            };
        }
      } catch (error) {
        console.error(error);
      }
    };

    const { isModalOpen, handleClick, produtos, atributos } = props;
    return (
        <Dialog className={styles.modal} open={isModalOpen} onClose={handleClick}>
            <Grid container className={styles.container}>
                <Grid item xs={6} className={styles.header}>
                    <Typography className={styles.title}>VER FICHA TÉCNICA</Typography>

                    <IconButton className={styles.closeButton} onClick={handleClick}>
                        <Close />
                    </IconButton>
                </Grid>

                <Grid item xs={6}>
                    {produtos && produtos.map((produto, index) => (
                        <CardProduto
                            key={index}
                            id_produto={produto.id}
                            produto={produto}
                            handleClickIconDownload={() => { handleClickIconDownload(atributos, produto.pdf_link) }}
                            handleClickIconView={() => { handleClickIconView(produto.pdf_link) }}
                            handleClickIconPrint={() => { handleClickIconPrint(produto.pdf_link) }}
                            pdf_link={produto.pdf_link}
                        />
                    ))}
                </Grid>
            </Grid>
        </Dialog>
    );
}
